import { ThemeProvider } from '@mui/material';
import theme from './theme/index'
import GlobalStyles from './components/GlobalStyles';
import Router from './routes';
import { BrowserRouter, RouterProvider } from "react-router-dom";
import './App.css';
import './fonts/Roboto.ttf';
import { useState, useEffect } from 'react';
import { socket } from './socket';
import moment from 'moment';
import 'moment/locale/ru';
import { gapi } from 'gapi-script';
import { QueryClient, QueryClientProvider } from 'react-query';
import Events from 'components/Events';
import Connector from 'components/socketLib/ConnectorSocket';
import { SnackbarProvider } from 'notistack';
import { DataProvider } from 'actions/contextDealClient';
import { setReduxStateGetter } from 'store/slices/loginSlice';
import store from 'store/store';
import { useDispatch } from 'react-redux'; 
import { isLogged } from 'store/slices/loginSlice'; 


const CLIENT_ID = '51099724195-fpa2pk9r6ltudi0u63rarc79qb85r20q.apps.googleusercontent.com';
const API_KEY = "AIzaSyARZabtLExhnaP8bzuDlPBteA8vYlyQ_tY";
const SCOPES = "https://www.googleapis.com/auth/documents https://www.googleapis.com/auth/drive.file";

// инициализация клиента react-query (библиотека предоставляет хуки для работы с запросами)
const queryClient = new QueryClient()
const App = () => {

  const dispatch = useDispatch();

  // Проверка авторизации при загрузке приложения
  useEffect(() => {
    console.log('App загружен, проверяем авторизацию...');
    // @ts-ignore
    dispatch(isLogged());
  }, [dispatch]);

  // функция для доступа к состоянию
  setReduxStateGetter(() => store.getState());

  // состояние для отслеживания подключения к сокету
  const [isConnected, setIsConnected] = useState(socket.connected);

  moment.updateLocale('ru', { week: { dow: 1 } });

  useEffect(() => {
    function start() {
      gapi.client.init({
        apiKey: API_KEY,
        clientId: CLIENT_ID,
        scope: SCOPES,
        discoveryDocs: ["https://docs.googleapis.com/$discovery/rest?version=v1", "https://www.googleapis.com/discovery/v1/apis/drive/v3/rest"],
      });
    }
    gapi.load("client:auth2", start);

    // обработчики событий подключения и отключения сокета
    function onConnect() {
      console.log('onConnect');
      setIsConnected(true);
    }

    function onDisconnect() {
      console.log('onDisconnect');
      setIsConnected(false);
    }

    socket.on('connection', onConnect);
    socket.on('disconnect', onDisconnect);

    return () => {
      socket.off('connect', onConnect);
      socket.off('disconnect', onDisconnect);
    };
  }, []);



  useEffect(() => {
    // Функция проверки версии
    const checkVersion = async () => {
      try {
        // Добавляем timestamp чтобы избежать кэширования
        const response = await fetch(`/version.json?t=${Date.now()}`);
        const serverData = await response.json();
        
        // Получаем текущую версию из localStorage
        const currentVersion = localStorage.getItem('app_version');
        
        console.log('Текущая версия:', currentVersion);
        console.log('Версия на сервере:', serverData.version);
        
        // Если версии разные - обновляем
        if (currentVersion && currentVersion !== serverData.version) {
          console.log('Обнаружена новая версия!');
          
          // Сохраняем новую версию
          localStorage.setItem('app_version', serverData.version);
          
          // Показываем уведомление пользователю
          if (window.confirm('Доступна новая версия сайта. Обновить?')) {
            // Очищаем кэш service worker если есть
            if ('caches' in window) {
              const cacheNames = await caches.keys();
              await Promise.all(
                cacheNames.map(name => caches.delete(name))
              );
            }
            
            // Принудительная перезагрузка с сервера
            window.location.reload();
          }
        } else if (!currentVersion) {
          // Первый запуск - сохраняем версию
          localStorage.setItem('app_version', serverData.version);
        }
      } catch (error) {
        console.error('Ошибка проверки версии:', error);
      }
    };

    // Проверяем при загрузке
    checkVersion();
    
    // Проверяем каждые 5 минут
    const interval = setInterval(checkVersion, 5 * 60 * 1000);
    
    // Проверяем при возвращении на вкладку
    const onVisibilityChange = () => {
      if (!document.hidden) {
        checkVersion();
      }
    };
    document.addEventListener('visibilitychange', onVisibilityChange);
    
    // Очистка при размонтировании
    return () => {
      clearInterval(interval);
      document.removeEventListener('visibilitychange', onVisibilityChange);
    };
  }, []); // Пустой массив зависимостей = выполнить один раз при загрузке

  return (
    <>
    {/* Обёртка QueryClientProvider, которая позволяет использовать хуки react-query в дочерних компонентах */}
    <QueryClientProvider client={queryClient}>
    {/* Обёртка Connector, которая позволяет использовать сокет в дочерних компонентах */}
      <Connector url={`${process.env.REACT_APP_SOCKET_URL}`} path={`${process.env.REACT_APP_SOCKET_PATH}`}>
      {/* Обёртка SnackbarProvider, которая позволяет использовать уведомления в дочерних компонентах */}
      <SnackbarProvider maxSnack={10} autoHideDuration={20000}>
      {/* Обёртка Events, которая позволяет использовать события сокета в дочерних компонентах */}
      <Events>
        {/* Обёртка ThemeProvider, которая позволяет использовать тему Material UI в дочерних компонентах */}
        <ThemeProvider theme={theme}>
          {/* Глобальные стили, которые применяются ко всему приложению */}
          <GlobalStyles />
          {/* Обёртка DataProvider, которая позволяет использовать контекст для работы с данными */}
          <DataProvider>
            { /* Обёртка BrowserRouter, которая позволяет использовать роутинг в приложении */}
          <RouterProvider router={Router} />
          </DataProvider>
        </ThemeProvider>
      </Events>
      </SnackbarProvider>
      </Connector>
    </QueryClientProvider>
    </>
  );
}


export default App;